/* eslint-disable react-refresh/only-export-components */
import {StrictMode, Suspense} from "react";
import {createRoot} from "react-dom/client";
import "./styles/global-styles.css";
import "./manageServiceWorker";
import {BrowserRouter, useRoutes} from "react-router-dom";
import {ShowMessages} from "./features/messenger/messenger.tsx";
import {I18n} from "./i18n.tsx";
import {UserRepoLoader} from "./models/UserRepo.ts";
import AuthRoutes from "./pages/auth/AuthRoutes.tsx";
import SyncUser from "./pages/auth/SyncUser.tsx";
import Welcome from "./pages/auth/Welcome.tsx";
import AppShell from "./shared/ui/AppShell.tsx";
import Spinner from "./shared/ui/Spinner.tsx";
import {Col} from "./ui/Box.tsx";
import ErrorBoundary from "./utils/ErrorBoundary.tsx";

const Routes = () => {
  const userRepo = UserRepoLoader.useRepo(null);
  return useRoutes([
    {path: "/welcome", element: <Welcome userRepo={userRepo} />},
    {path: "/sync/:secret", element: <SyncUser userRepo={userRepo} />},
    {
      path: "*",
      element: <AuthRoutes userRepo={userRepo} />,
    },
  ]);
};

const LoadingFallback = () => (
  <AppShell>
    <Col align="center" justify="center" flex="auto">
      <Spinner size="48" />
    </Col>
  </AppShell>
);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <Suspense fallback={<LoadingFallback />}>
        <I18n>
          <>
            <BrowserRouter>
              <Routes />
            </BrowserRouter>
            <ShowMessages />
          </>
        </I18n>
      </Suspense>
    </ErrorBoundary>
  </StrictMode>
);
